import { ROUTE_PATHS } from 'core/constants/routePath'
import { UserContext } from 'core/contexts/UserContext'
import { IMessage, UserType } from 'core/interfaces/Conversation'
import { RootState } from 'core/store'
import { useConverseMutation } from 'iastart/api/conversation'
import { IConverseBody } from 'iastart/interfaces/Conversation'
import {
  addMessage,
  getGuid,
  resetConversation,
} from 'iastart/store/slices/conversationSlice'
import { useContext } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router'

export const useHandleConversation = (application: string) => {
  const [converse, { isLoading }] = useConverseMutation()
  const dispatch = useDispatch()
  const guid = useSelector((state: RootState) => getGuid(state, application))
  const navigate = useNavigate()
  const { user: currentUser } = useContext(UserContext)

  const handleConverse = (message: string) => {
    const idClient = currentUser?.idClient
    if (!idClient) {
      return false
    }

    const body: IConverseBody = {
      idClient,
      application,
      params: {
        consigne: JSON.stringify(message),
      },
    }
    if (guid) {
      body.guid = guid
    } else {
      body.guid = null
    }
    converse(body)
      .unwrap()
      .then((response) => {
        const userMessage: IMessage = {
          type: UserType.USER,
          timestamp: Date.now(),
          content: message,
        }
        dispatch(
          addMessage({
            application,
            message: userMessage,
            guid: response.guid,
          })
        )
        const iaMessage: IMessage = {
          type: UserType.ASSISTANT,
          timestamp: Date.now(),
          content: response.answer,
          id: response.message_id,
        }
        dispatch(
          addMessage({
            application,
            message: iaMessage,
            guid: response.guid,
          })
        )
      })
      .catch((error) => {
        console.error(error)
        navigate(ROUTE_PATHS.ERROR)
      })
  }
  const handleResetConversation = (applicationName: string = application) => {
    dispatch(resetConversation({ application: applicationName }))
  }

  return {
    handleConverse,
    isLoading,
    handleResetConversation,
  }
}
